import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Routewrapper die alleen ingelogde gebruikers doorlaat.
 * Onthoudt het oorspronkelijke pad zodat Login daar na het inloggen naartoe kan sturen.
 */
function RequireAuth({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export default RequireAuth;
